import { setItem } from 'helpers/localstorage';

export const checkForValidAudienceForCashFundingExp =
  () => (dispatch, getState) => {
        setItem('BOOSTER_RELAUNCH_SIGNUP', true);
  };
